import { FC, useEffect } from 'react'
import ReactPaginate from 'react-paginate'

import Participant from 'components/artistsPage/Participant'
import { Participants } from './styles'
import { Artist } from 'models/artists/ApiModels'

type PaginatedListType = {
  data: Artist[]
  limit: number
  setOffset: (number) => void
  artistsCount: number
  onClear?: () => void
  offset: number
  scrollToElement: () => void
}

const PaginatedList: FC<PaginatedListType> = ({
  data,
  limit,
  setOffset,
  offset,
  artistsCount,
  onClear,
  scrollToElement
}) => {
  const pagesCount = Math.ceil((artistsCount || 0) / limit)

  useEffect(() => {
    // onClear() TODO: уточнить по поводу очищения поиска
  }, [])

  const onPageChange = ({ selected }) => {
    const offset = selected * limit
    setOffset(offset)
    scrollToElement()
  }

  return (
    <>
      <Participants>
        {data &&
          data.map(artist => (
            <Participant
              key={artist.id}
              id={artist.id}
              name={artist.name}
              country={artist.country}
              city={artist.city}
              imageSrc={artist.photo}
            />
          ))}
      </Participants>
      {pagesCount > 1 && (
        <ReactPaginate
          previousLabel={<img src="/svgs/page-prev.svg" />}
          nextLabel={<img src="/svgs/page-next.svg" />}
          breakLabel={'...'}
          pageCount={pagesCount}
          breakClassName={'break-me'}
          marginPagesDisplayed={1}
          pageRangeDisplayed={3}
          containerClassName={'pagination'}
          subContainerClassName={'pages pagination'}
          activeClassName={'active'}
          onPageChange={onPageChange}
          forcePage={offset / limit}
        />
      )}
    </>
  )
}

export default PaginatedList
